/**
 * @desc 查询剩余可识别额度
 */
import { OcrLimitResult, OcrLimitParam } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryOcrLimitParameter = OcrLimitParam

const method = 'GET'
const url = '/nexus/ocr/limit'

export const queryOcrLimitApi = (
  params?: QueryOcrLimitParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<OcrLimitResult>({
    method,
    url,
    params,
    ...config
  })
}

queryOcrLimitApi.method = method
queryOcrLimitApi.url = url
